/* hk-cart-v1 (15 Aug): the drawer's persistent free-shipping ladder, the
   money-in-button checkout label, and a 5-second undo after a line removal.

   Replaces hk-ship-nudge (a 7-second toast nobody caught). The upsell row
   stays with hk-cart-upsell-v24 + hk-pack-upgrade-v5: that pair carries the
   morph/rollback/stock scars from 8 Aug and is not re-fought here.

   Same constraints as v24: Horizon morphs the cart section on every update
   and discards injected nodes, so the ladder re-inserts after each render,
   idempotently, keyed by id. ES5 only. A throw must never reach the cart. */
(function () {
  "use strict";
  if (window.__hkCartV1) return;
  window.__hkCartV1 = true;
  window.HK_CART_VER = "2026-08-15a";

  if (!window.fetch || !window.Promise || !document.querySelector) return;

  var FREE_CENTS = 7000;
  var LADDER_ID = "hk-ladder";
  var lastItems = null;   /* variant_id -> {qty, title} from the previous cart read */
  var celebrated = false; /* stage-2 flip shown once per crossing */

  function money(c) { return "$" + (Math.abs(c) / 100).toFixed(2).replace(/\.00$/, ""); }

  function readCart(cb) {
    fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (c) { if (c) cb(c); })
      .catch(function () {});
  }

  /* ---------------- ladder ---------------- */
  function ladderHTML(total) {
    if (total >= FREE_CENTS) {
      var msg = "Free post unlocked.";
      return '<div class="hk-ladder__bar"><span class="hk-ladder__fill" style="width:100%"></span></div>' +
             '<p class="hk-ladder__text hk-ladder__text--done">' + msg + "</p>";
    }
    var gap = FREE_CENTS - total;
    var pct = Math.max(6, Math.min(96, Math.round((total / FREE_CENTS) * 100)));
    return '<div class="hk-ladder__bar"><span class="hk-ladder__fill" style="width:' + pct + '%"></span></div>' +
           '<p class="hk-ladder__text">You’re <strong>' + money(gap) + "</strong> from free post</p>";
  }

  function hosts() {
    var out = [];
    var d = document.querySelector("cart-drawer-component .cart-drawer__content");
    if (d) out.push(d);
    var m = document.querySelector("cart-items-component");
    if (m && !(d && d.contains(m))) out.push(m);   /* inside the items column, not above the whole page */
    return out;
  }

  function renderLadder(cart) {
    var hs = hosts();
    for (var i = 0; i < hs.length; i++) {
      var host = hs[i];
      var el = host.querySelector ? host.querySelector("#" + LADDER_ID) : null;
      if (cart.item_count === 0) { if (el) el.parentNode.removeChild(el); continue; }
      if (!el) {
        el = document.createElement("div");
        el.id = LADDER_ID;
        el.setAttribute("role", "status");
        /* ladder under the heading on the cart page; first thing in the drawer */
        var title = host.querySelector("h1, h2");
        while (title && title.parentNode && title.parentNode !== host) title = title.parentNode;
        if (title && title.parentNode === host) host.insertBefore(el, title.nextSibling);
        else if (host.firstChild) host.insertBefore(el, host.firstChild);
        else host.appendChild(el);
      }
      var html = ladderHTML(cart.total_price);
      if (el.innerHTML !== html) el.innerHTML = html;   /* an unchanged write still fires the observer */
    }
    if (cart.total_price >= FREE_CENTS && !celebrated) {
      celebrated = true;
      setTimeout(function () { readCart(renderLadder); }, 2000);
    }
    if (cart.total_price < FREE_CENTS) celebrated = false;
  }

  /* ---------------- checkout button total ---------------- */
  function renderButton(cart) {
    var spans = document.querySelectorAll("[data-hk-total]");
    var label = money(cart.total_price);
    for (var i = 0; i < spans.length; i++) if (spans[i].textContent !== label) spans[i].textContent = label;
  }

  /* ---------------- undo after removal ---------------- */
  function snapshot(cart) {
    var m = {};
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      m[it.variant_id] = { qty: it.quantity, title: it.product_title };
    }
    return m;
  }

  var snack = null, snackTimer = null;
  function showUndo(variantId, qty, title) {
    if (!snack) {
      snack = document.createElement("div");
      snack.id = "hk-undo";
      snack.setAttribute("role", "status");
      snack.style.cssText = "position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#2A2620;color:#F3EDE3;padding:12px 18px;border-radius:8px;font-size:15px;z-index:9000;box-shadow:0 4px 14px rgba(0,0,0,.3);display:flex;gap:14px;align-items:center;max-width:92vw";
      document.body.appendChild(snack);
    }
    snack.innerHTML = "<span>Removed “" + String(title).replace(/[<>&]/g, "") + "”.</span>" +
      '<button id="hk-undo-btn" style="background:none;border:none;color:#E4EAE0;font-weight:700;font-size:15px;text-decoration:underline;cursor:pointer;padding:0">Undo</button>';
    snack.style.display = "flex";
    var btn = document.getElementById("hk-undo-btn");
    btn.onclick = function () {
      btn.disabled = true;
      fetch("/cart/add.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      }).then(function (r) {
        hideUndo();
        if (r && r.ok) {
          readCart(function (cart) {
            var ev;
            try { ev = new Event("cart:update", { bubbles: true }); } catch (e) { ev = document.createEvent("Event"); ev.initEvent("cart:update", true, false); }
            ev.detail = { resource: cart, sourceId: "hk-cart", data: { source: "hk-cart", itemCount: cart.item_count } };
            document.dispatchEvent(ev);
          });
          refresh();
        }
      }).catch(function () { hideUndo(); });
    };
    if (snackTimer) clearTimeout(snackTimer);
    snackTimer = setTimeout(hideUndo, 5000);
  }
  function hideUndo() { if (snack) snack.style.display = "none"; }

  var swapUntil = 0;
  function packCount(m) { var n = 0; for (var k in m) if (/Bottle Pack/i.test(m[k].title || "")) n++; return n; }
  function diffForUndo(cart) {
    var now = snapshot(cart);
    /* A pack swap removes singles on the customer's behalf. That is not a
       removal to undo, so nothing is offered while a swap has just landed or
       when a pack line has appeared in place of the singles. */
    var swap = Date.now() < swapUntil || (lastItems && packCount(now) > packCount(lastItems));
    if (lastItems && !swap) {
      for (var vid in lastItems) {
        if (!now[vid] && lastItems[vid].qty > 0) {
          /* the free kit is $0 and system-managed; never offer to restore it */
          if (/starter (kit|pack)/i.test(lastItems[vid].title || "")) continue;
          showUndo(vid, lastItems[vid].qty, lastItems[vid].title);
          break;
        }
      }
    }
    lastItems = now;
  }

  /* ---------------- wiring ---------------- */
  var pending = null;
  function refresh() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      readCart(function (cart) {
        renderLadder(cart);
        renderButton(cart);
        diffForUndo(cart);
      });
    }, 100);
  }

  document.addEventListener("cart:update", function (e) {
    if (e && e.detail && e.detail.sourceId === "hk-pack-upgrade") swapUntil = Date.now() + 6000;
  });
  document.addEventListener("cart:update", refresh);

  /* Horizon morphs the drawer without always firing cart:update on open. */
  var mo = null;
  function observe() {
    var drawer = document.querySelector("cart-drawer-component");
    if (!drawer || mo) return;
    /* Our own writes (the ladder, the undo bar) must not re-trigger a refresh,
       or the observer and the render chase each other and hammer /cart.js. */
    mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        var el = t.nodeType === 1 ? t : t.parentNode;
        if (el && el.closest && el.closest("#hk-ladder, #hk-undo, [data-hk-total]")) continue;
        refresh();
        return;
      }
    });
    mo.observe(drawer, { childList: true, subtree: true });
  }

  function boot() { observe(); refresh(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
